import { render, staticRenderFns } from "./TableContainer.vue?vue&type=template&id=3133eca5&scoped=true&"
import script from "./TableContainer.vue?vue&type=script&lang=js&"
export * from "./TableContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133eca5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3133eca5')) {
      api.createRecord('3133eca5', component.options)
    } else {
      api.reload('3133eca5', component.options)
    }
    module.hot.accept("./TableContainer.vue?vue&type=template&id=3133eca5&scoped=true&", function () {
      api.rerender('3133eca5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/table/TableContainer.vue"
export default component.exports